var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-float"},_vm._l((_vm.floats),function(float){return _c('div',{key:float.id,class:['c-float__item', float.klass]},[_vm._v("Copied")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }